'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'user-account',
    elem: 'name',
    tag: 'span',
    content: function content(_ref) {
        var text = _ref.text,
            children = _ref.children;

        return children || text;
    }
}, {
    propTypes: {
        text: _propTypes2.default.string
    }
});